module.exports = __webpack_public_path__ + "img/appstore1.65fb7965.png";